export default __webpack_public_path__ + "static/media/Order Management.a57be2ac.png";